'use client';

import * as DS from '@aurorasolar/ds';
import { useIntl } from '@aurorasolar/intl';
import { useCallback } from 'react';

export const useCurrency = () => {
  const intl = useIntl();

  const formatCurrency = useCallback(
    (num: number | null | undefined, digits = 0) => {
      if (num == null) {
        return DS.FALLBACK_PLACEHOLDER_STRING;
      }

      return intl.formatNumber(num, {
        currency: 'USD',
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
        style: 'currency',
      });
    },
    [intl]
  );

  const formatPercent = useCallback(
    (num: number | null | undefined) => {
      if (num == null) {
        return DS.FALLBACK_PLACEHOLDER_STRING;
      }

      return intl.formatNumber(num, { maximumFractionDigits: 8, style: 'percent' });
    },
    [intl]
  );

  return { formatCurrency, formatPercent };
};
